/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candid_Smug_Bird_WishInputs */

const fr_candid_smug_bird_wish = /** @type {(inputs: Candid_Smug_Bird_WishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter les personnes`)
};

/**

* @param {Candid_Smug_Bird_WishInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const candid_smug_bird_wish = /** @type {((inputs?: Candid_Smug_Bird_WishInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candid_Smug_Bird_WishInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_candid_smug_bird_wish(inputs)
});